import axios from "./http";
let { get, post } = axios

// order
export const execute_order = data => post("/mcapi/cwcash/executecworder", data)

// getorder
export const getorder = data => get("/mcapi/cwcash/getorderinfo", data)

// upirefno
export const backfillutr = data => post("/mcapi/cwcach/backfillutr", data)

// query
export const cwquery = data => get("/mcapi/cwcach/cwquery", data)

// process
export const process = data => post("/mcapi/cwcash/process", data)
